import React from "react";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { PaymentReminderConfigWizard } from "../components/PaymentReminderConfigWizard";
import { IPaymentReminderConfigForm } from "../types/paymentReminderConfig.types";

interface PaymentReminderConfigDialogProps {
  open: boolean;
  onClose: () => void;
  initialData?: IPaymentReminderConfigForm | null;
  onSuccess?: () => void;
}

/**
 * Dialog wrapper around the PaymentReminderConfigWizard.
 * Opens from the Settings button when config already exists.
 */
export const PaymentReminderConfigDialog: React.FC<
  PaymentReminderConfigDialogProps
> = ({ open, onClose, initialData, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Payment Reminder Configuration"
      size="lg"
    >
      <PaymentReminderConfigWizard
        mode="dialog"
        initialData={initialData}
        onSuccess={handleSuccess}
        onCancel={onClose}
      />
    </Dialog>
  );
};
